import { render, staticRenderFns } from "./Spending.vue?vue&type=template&id=50b7f1f4&"
import script from "./Spending.vue?vue&type=script&lang=js&"
export * from "./Spending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b7f1f4')) {
      api.createRecord('50b7f1f4', component.options)
    } else {
      api.reload('50b7f1f4', component.options)
    }
    module.hot.accept("./Spending.vue?vue&type=template&id=50b7f1f4&", function () {
      api.rerender('50b7f1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serviceDetails/Spending.vue"
export default component.exports